import { createContext, useState } from 'react';

import MemberAdministrationLscLifeMemberRenewalsData from './MemberAdministrationLscLifeMemberRenewalsData';

export const MemberAdministrationLscLifeMemberRenewalsStateContext = createContext();

const MemberAdministrationLscLifeMemberRenewalsContextProvider = ({ children }) => {
  const stateHook = useState(MemberAdministrationLscLifeMemberRenewalsData.INITIAL_STATE);

  return (
    <MemberAdministrationLscLifeMemberRenewalsStateContext.Provider value={stateHook}>
      {children}
    </MemberAdministrationLscLifeMemberRenewalsStateContext.Provider>
  );
};

export default MemberAdministrationLscLifeMemberRenewalsContextProvider;